/**
 * Groove PDF Page 1 Component
 * 
 * Renders the first page of WPS (Welding Procedure Specification) PDF for Groove welding type.
 * Contains:
 * - WPS Header with company info and procedure details
 * - Base Metals table (QW-403) with thickness range qualifications
 * - Filler Metals table (QW-404) with thickness range qualifications  
 * - Welding Procedure table with process parameters for up to 3 welding processes
 * 
 * Supports both Groove and Overlay welding types with dynamic column sizing
 * based on number of welding processes (1-3 processes)
 */

import "../Css/Download_pdf.css";
import Groove_pdf_header from "./Groove_pdf_header WPS";
import { BaseMetalTable, FillerMetalTable } from "./common";
import Groove_Pdf_Fields from "./common/WPS_Groove_pdf_fields_in_json";

import Overlay_Pdf_Fields from "./common/WPS_Overlay_Welding_procedure_Json";

const Groove_pdf_page1 = ({ pdf }) => {
  const getColumnWidth = () => {
    if (pdf[2] === undefined) return "70%";
    return pdf[3] !== undefined ? "23%" : "35%";
  };
  
  const getCol2Class = () => {
    if (pdf[2] === undefined) return "WPStdhidden";
    return pdf[3] !== undefined ? "WPSleft7-td" : "WPSleft7-td-noright";
  };
  
  const getProcessDataWidth = () => {
    if (pdf.length < 3) return "process1";
    if (pdf.length < 4) return "process2";
    return "process3";
  };
  
  const colwidth = getColumnWidth();
  const col1Class = "WPSleft7-td-noleft";
  const col2Class = getCol2Class();
  const col3Class = pdf[3] !== undefined ? "WPSleft7-td-noright1" : "WPStdhidden";
  const WPSProcessDataWidth = getProcessDataWidth();
  
  const styles = {
    group: { display: "flex" }
  };
  
  let WPType = pdf[0].wld_WPSType !== "Overlay" ? Groove_Pdf_Fields : Overlay_Pdf_Fields;

  function bindewldprocess(type, processindex) {
    const processValues = pdf[processindex]?.[type] || [];
    
    const filledCount = processValues.filter(v => v !== "").length;
    console.log("processclass",filledCount,type)
    let processClass,processwidth;
    if (filledCount === 1) {
      processClass = "insideprocess";
      processwidth = "450px";
    } else if (filledCount === 2) {
      processClass = "insideprocess1";
        processwidth = "200px";
    } else {
      processClass = "insideprocess2";
       processwidth = "200px";
    }
    
    return [
      <tr key={1} style={{ background: "none" }}>
        {processValues.map((value, index) => 
          value && (
            <td key={1} className={`${WPSProcessDataWidth} ${processClass}`} style={{ width:{processwidth}}}>
              {value}
            </td>
          )
        )}
      </tr>
    ];
  }

  return (
    <div className="WPSMainPDF">
      <Groove_pdf_header pdf={pdf}></Groove_pdf_header>
      
      {/* Table 1 */}
      {/* BASE METAL */}
      <div style={{ position: "relative", top: "7px" }}>
        <div style={styles.group}>
          <div className="WPSbasemetal">BASE METALS (QW-403)</div>
          <div className="WPSemptyTitle" style={{ width: "31%" }}></div>
          <div className="WPSPthickness">THICKNESS RANGE QUALIFIED</div>
          <div className="WPSmesursment">mm</div>
        </div>
        
        {/* Table 2 */}
        <BaseMetalTable pdf={pdf} type={pdf[0].wld_WPSType} />
        
        {/* Table 4 */}
        <div className="WPSgroup">
          <div className="WPStitle5">FILLER METALS (QW-404)</div>
          <div className="WPSemptyTitle" style={{ width: "3%" }}></div>
          <div className="WPSemptytitle" style={{ width: "33%" }}></div>
          <div className="WPStitle5">THICKNESS RANGE QUALIFIED</div>
          <div className="WPSemptyTitle" style={{ width: "2%" }}></div>
          <div className="WPSmesursment" style={{ paddingLeft: "1.1px" }}>mm</div>
        </div>
        
        {/* Table 5 */}
        <div>
          <div style={{ paddingTop: ".1px" }}></div>
          <FillerMetalTable pdf={pdf} type="Standard" />
        </div>
        
        {/* Welding Procedure */}
        <div 
          className="WPSgroup" 
          style={{ align: "right", textAlign: "right", width: "50%" }}
        >
          <div className="WPStitle5">WELDING PROCEDURE</div>
        </div>
        
        {/* Welding Procedure Table */}
        <table id="table" className="WPSTable7">
          <tbody>
            {WPType.map((i, count) => {
              // debugger;
              let value1 = pdf[1]?.[i.FieldName];
              let value2 = pdf[2]?.[i.FieldName];
              let value3 = pdf[3]?.[i.FieldName];
              
              if (i.Process !== undefined) {
                value1 += "-" + (pdf[1] ? pdf[1].WPSD_Type : "");
                value2 += "-" + (pdf[2] ? pdf[2].WPSD_Type : "");
                value3 += "-" + (pdf[3] ? pdf[3].WPSD_Type : "");
              } else if (i.Colums && i.Colums.length > 0) {
                value1 = bindewldprocess(i.Colums[0], 1);
                value2 = bindewldprocess(i.Colums[1], 2);
                value3 = bindewldprocess(i.Colums[2], 3);
              }
              
              let paddingleft = i.ColumnDesc !== "" ? "WPSwithLeftrcorner" : "WPSwithoutLeftrcorner";
              let middleLeft = i.ColumnDesc !== "" ? "WPSMidwithLefttext" : "WPSMidwithoutLefttext";
              let midtext;
              if (i.Suffix === "Trailing") {
                midtext = <>&nbsp;&nbsp;&nbsp;{i.MiddleDesc}</>;
              } else if (i.Suffix === "Backing") {
                midtext = <>&nbsp;&nbsp;{i.MiddleDesc}</>;
              } else {
                midtext = <>{i.MiddleDesc}</>;
              }
              
              let rowClass = "WPStrhide";
              let ThClass = "WPSthhide";
              
              if (count === 0) {
                rowClass = "WPStrFirstRow";
                ThClass = "WPSthhideFirstRow";
              }
              
              if (count === WPType.length - 1) {
                ThClass = "WPSthhideLastRow";
                rowClass = "WPStrLastRow";
              }
              
              return (
                <tr key={i.FieldName || count} className={rowClass}>
                  <th className={ThClass} style={{ width: "27%" }}>
                    {i.MiddleDesc !== undefined ? (
                      <div className="WPSgroup">
                        <div className="WPSlcorner">{i.ColumnDesc}</div>
                        <div className={middleLeft}>{midtext}</div>
                        <div className={paddingleft}>{i.Unit}</div>
                      </div>
                    ) : (
                      <>
                        <div className="WPSlcorner">{i.ColumnDesc}</div>
                        <div className="WPSrcorner1">{i.Unit}</div>
                      </>
                    )}
                  </th>
                  <td className={col1Class} style={{ width: { colwidth } }}>
                    {value1}
                  </td>
                  <td className={col2Class} style={{ width: { colwidth } }}>
                    {value2}
                  </td>
                  <td className={col3Class} style={{ width: { colwidth } }}>
                    {value3}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      
      <br />
      
      <div id="footer" style={{ position: "fixed", top: "825px" }}>
        <table className="WPSfooter">
          <tbody>
            <tr>
              <td>Page 1 of 2</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Groove_pdf_page1; 
